import { Container, Row, Col, Carousel } from 'react-bootstrap';
import { StarFill, Quote } from 'react-bootstrap-icons';
import ScrollAnimation from 'react-animate-on-scroll';

const testimonials = [
  {
    id: 1,
    name: 'Sarah M.',
    location: 'Austin, TX',
    rating: 5,
    text: 'I had no idea my injury could be worth so much. This tool gave me the confidence to pursue my claim. The estimate was spot on!',
    avatar: null,
  },
  {
    id: 2,
    name: 'James R.',
    location: 'Miami, FL',
    rating: 5,
    text: 'Quick, easy, and actually accurate. I used the estimate to negotiate with the insurance company and got a fair settlement.',
    avatar: null,
  },
  {
    id: 3,
    name: 'Michelle K.',
    location: 'Denver, CO',
    rating: 5,
    text: 'I was hesitant at first, but the process was so simple. Within 2 minutes I knew what my back injury claim could be worth.',
    avatar: null,
  },
  {
    id: 4,
    name: 'David L.',
    location: 'Chicago, IL',
    rating: 5,
    text: 'No phone calls, no pressure, just a straightforward estimate. Exactly what I needed to make an informed decision.',
    avatar: null,
  },
];

const stats = [
  { value: '10,000+', label: 'Estimates Generated' },
  { value: '4.9/5', label: 'Average Rating' },
  { value: '50', label: 'States Covered' },
  { value: '$2.5M+', label: 'Total Claims Estimated' },
];

function StarRating({ rating }) {
  return (
    <div className="qmi-stars">
      {[...Array(5)].map((_, i) => (
        <StarFill
          key={i}
          size={16}
          className={i < rating ? 'qmi-star-filled' : 'qmi-star-empty'}
        />
      ))}
    </div>
  );
}

function TestimonialCard({ testimonial }) {
  return (
    <div className="qmi-testimonial-card">
      <Quote size={32} className="qmi-testimonial-quote" />
      <p className="qmi-testimonial-text">{testimonial.text}</p>
      <div className="qmi-testimonial-author">
        <div className="qmi-testimonial-avatar">
          {testimonial.avatar ? (
            <img src={testimonial.avatar} alt={testimonial.name} />
          ) : (
            <span>{testimonial.name.charAt(0)}</span>
          )}
        </div>
        <div className="qmi-testimonial-info">
          <div className="qmi-testimonial-name">{testimonial.name}</div>
          <div className="qmi-testimonial-location">{testimonial.location}</div>
        </div>
        <StarRating rating={testimonial.rating} />
      </div>
    </div>
  );
}

export function Testimonials() {
  return (
    <section className="qmi-testimonials qmi-section qmi-section-light">
      <Container>
        <ScrollAnimation animateIn="fadeIn" animateOnce={true}>
          <div className="text-center mb-5">
            <span className="qmi-section-label">What People Say</span>
            <h2 className="qmi-title racing-sans-one-regular">
              Trusted by Thousands
            </h2>
            <p className="qmi-subtitle mx-auto">
              Join thousands of people who have used our tool to understand their claim's value.
            </p>
          </div>
        </ScrollAnimation>

        {/* Stats Row */}
        <ScrollAnimation animateIn="fadeInUp" animateOnce={true}>
          <Row className="qmi-stats-row mb-5">
            {stats.map((stat, index) => (
              <Col xs={6} md={3} key={index} className="mb-3 mb-md-0">
                <div className="qmi-stat-item">
                  <div className="qmi-stat-value">{stat.value}</div>
                  <div className="qmi-stat-label">{stat.label}</div>
                </div>
              </Col>
            ))}
          </Row>
        </ScrollAnimation>

        {/* Desktop: Grid of testimonials */}
        <div className="d-none d-md-block">
          <Row>
            {testimonials.slice(0, 4).map((testimonial, index) => (
              <Col md={6} lg={3} key={testimonial.id} className="mb-4">
                <ScrollAnimation
                  animateIn="fadeInUp"
                  animateOnce={true}
                  delay={index * 100}
                >
                  <TestimonialCard testimonial={testimonial} />
                </ScrollAnimation>
              </Col>
            ))}
          </Row>
        </div>

        {/* Mobile: Carousel */}
        <div className="d-md-none">
          <Carousel
            indicators={true}
            controls={false}
            interval={5000}
            className="qmi-testimonial-carousel"
          >
            {testimonials.map((testimonial) => (
              <Carousel.Item key={testimonial.id}>
                <TestimonialCard testimonial={testimonial} />
              </Carousel.Item>
            ))}
          </Carousel>
        </div>
      </Container>
    </section>
  );
}
